// extracted by mini-css-extract-plugin
export default {"Row":"_Row--HWYtw","Note":"_Note--AzoD3","FirstChildFixedHeight":"_FirstChildFixedHeight--EyHpZ","Buttons":"_Buttons--BQ9Az"};